import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { AddLeagueLayer } from '../components/GameLeague/AddLeagueLayer'

export const AddLeaguePage = () => {
  return (
    <MasterLayout>
        <AddLeagueLayer />
    </MasterLayout>
  )
}
